module.exports = __webpack_public_path__ + "assets/orai-logo.f118e711.svg";